import { IconVariant } from '@/components/icons/types';
import { Tracking } from '@/types/analytics';
import { ReactNode } from 'react';
import { z } from 'zod';
import { TabIdentifier as Identifier } from './MegaMenu.constants';

export type UseMegaMenuManagerProps = {
  tabs?: TabItem[];
  navigationContainerId?: string;
};

export type UseMegaMenuManagerOutput = {
  navRef: React.RefObject<HTMLElement>;
  navigationContainerRef: React.RefObject<HTMLDivElement>;
  navigationContainerId: string;
  tabs: TabItem[];
  activeTab?: TabIdentifier;
  activeSubcategory?: TabIdentifier;
  renderNavigationContainer: (props: UseMegaMenuManagerOutput) => ReactNode;
  onNavigationOpen: (identifier: TabIdentifier) => void;
  onSubCategoryNavigationOpen: (identifier: TabIdentifier, screenName: Tracking.ScreenName) => void;
  onSubCategoryNavigationLeave: () => void;
  onNavigationLeave: (blockTabHover?: TabIdentifier) => void;
  onMouseEnter: (identifier: TabIdentifier, screenName: Tracking.ScreenName) => void;
  onMouseLeave: () => void;
};

export const tabIdentifierSchema = z.enum([
  Identifier.Categories,
  Identifier.Hairdresser,
  Identifier.Massage,
  Identifier.Nails,
  Identifier.Lashes,
  Identifier.Skincare,
  Identifier.Beauty,
  Identifier.Health,
  Identifier.More,
  Identifier.Giftcard,
  Identifier.Wellnesscard,
  Identifier.SistaMinuten,
]);

export type TabIdentifier = z.infer<typeof tabIdentifierSchema>;

export type TabItem = {
  icon?: IconVariant;
  label: string;
  to?: string;
  className?: string;
  identifier: TabIdentifier;
  breakpoint?: string;
};

export type MegaMenuCategory = {
  identifier: TabIdentifier;
  categories: {
    title: string;
    icon: IconVariant;
    links: { label: string; to: string }[];
  }[];
};
